import { Administration } from '../administration/Administration';
import { selectActiveAccount, setAccount } from 'src/reducers/account.reducer';
import { useSelector } from 'react-redux';
import TitlePage from '../titlePage/TitlePage';
import { Subtitle, UserAdministrationContainer } from './UserAdministration.styles';

const UserAdministration = () => {
  const activeAccount = useSelector(selectActiveAccount);

  return (
    <UserAdministrationContainer>
      <TitlePage title='Administration' />

      <Subtitle>Liste des utilisateurs</Subtitle>
      <Administration account={activeAccount} setAccount={setAccount} admin={false} />
    </UserAdministrationContainer>
  );
};

export default UserAdministration;
